export default "__VITE_ASSET__b149e463__"